import { getStorage, setStorage } from './storage';

export let setMemberId = memberId => {
  setStorage('memberId', memberId);
};

export let getMemberId = () => {
  return getStorage('memberId');
};

export let setBranchId = branchId => {
  setStorage('branchId', branchId);
};

export let getBranchId = () => {
  return getStorage('branchId');
};
